module.exports = __webpack_public_path__ + "static/DSC_9510-b5e2bc324c5c86ebb8698c4534dd370a.jpg";